import styled from "styled-components"

const BlockTitle = styled.h3`
    color: ${props => props.theme.colors.secondary};
    padding: 1.5rem 0 1rem 0;
    margin: 0 !important;
    text-transform: uppercase;
`

export default BlockTitle